import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router'
import { AuthService } from './auth.service'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import mixpanel from 'mixpanel-browser';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    public auth: AuthService,
    public router: Router
  ) { }

  canActivate(route?: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canActivateChild(route)
  }

  canActivateChild(route?: ActivatedRouteSnapshot): Observable<boolean> {
    let pathGroupName = localStorage.getItem('pathGroupName')
    const loginToken = route?.queryParamMap.get('t')
    const loginQueryParams = loginToken ? { t: loginToken } : {}
    return this.auth.isAuthenticated().pipe(map(result => {
    //  mixpanel.track("Check protected pages accessability via token availability ", {result: result})
      if (result) return true
      mixpanel.track("Check pages accessability via token availability ", {result: result,pathGroupName: pathGroupName })
      if (pathGroupName) {
         this.router.navigate(['login', pathGroupName], { queryParams: loginQueryParams })
      } else {
         this.router.navigate(['login'], { queryParams: loginQueryParams })
      }
      return false
    }))
  }
}
